class MouseEnterWorker {
    constructor(menu) {

        this._menu = menu;
        this._timeoutForShow = +menu.options.timeoutForShow;
        this._timeoutForHide = +menu.options.timeoutForHide;

        this._onTriggerEnter = this._onTriggerEnter.bind(this);
        this._onTriggerLeave = this._onTriggerLeave.bind(this);

        var triggerEl = menu.getTriggerEl(), el = menu.getEl();

        el.addEventListener('mouseenter', this._onTriggerEnter);
        el.addEventListener('mouseleave', this._onTriggerLeave);

        triggerEl.addEventListener('mouseenter', this._onTriggerEnter);
        triggerEl.addEventListener('mouseleave', this._onTriggerLeave);

    }

    _onTriggerEnter(e) {
        if (this._jobDefferedHide) {
            this._clearDefferedHideJob();
        } else {
            this._jobDefferedShow = setTimeout(
                this._onJobDefferedShowSuccess.bind(this),
                this._timeoutForShow
            );
        }
    }

    _onTriggerLeave(e) {
        if (this._jobDefferedShow) {
            this._clearDefferedShowJob();
        } else {
            this._jobDefferedHide = setTimeout(
                this._onJobDefferedHideSuccess.bind(this),
                this._timeoutForHide
            );
        }
    }

    _onJobDefferedShowSuccess() {
        this._jobDefferedShow = null;
        this._menu.show();
    }

    _onJobDefferedHideSuccess() {
        this._jobDefferedHide = null;
        this._menu.hide();
    }

    // =========== Destruction ============
    _clearDefferedShowJob() {
        if (this._jobDefferedShow) {
            clearTimeout(this._jobDefferedShow);
            this._jobDefferedShow = null;
        }
    }

    _clearDefferedHideJob() {
        if (this._jobDefferedHide) {
            clearTimeout(this._jobDefferedHide);
            this._jobDefferedHide = null;
        }
    }

    destroy() {

        this._clearDefferedShowJob();
        this._clearDefferedHideJob();

        var menu = this._menu, triggerEl = menu.getTriggerEl(), el = menu.getEl();

        el.removeEventListener('mouseenter', this._onTriggerEnter);
        el.removeEventListener('mouseleave', this._onTriggerLeave);

        triggerEl.removeEventListener('mouseenter', this._onTriggerEnter);
        triggerEl.removeEventListener('mouseleave', this._onTriggerLeave);

        OK.util.clean(this);

    }
}


export default MouseEnterWorker;
